(function (angular) {
    'use strict';

    angular.module('app')
        .directive('ticket', ticket);

    ticket.$inject = [
        'EventOrdersApi'
    ];

    function ticket(EventOrdersApi) {
        return {
            templateUrl: 'directives/ticket.html',
            scope: {
                event: '=',
                children: '=',
                tickets: '=',
            },
            link: function ($scope) {
                $scope.$watch('children', getPrice);
                $scope.$watch('event', getPrice);

                function getPrice() {
                    if (!$scope.event) {
                        return;
                    }

                    // EventOrdersApi.cost({
                    //     'event_id': $scope.event.id,
                    //     'subevents[]': $scope.children.map(function (child) {
                    //         if (typeof child === 'object') {
                    //             return child.id;
                    //         }

                    //         return child;
                    //     }),
                    //     'total_tickets': 1
                    // }, function (response) {
                    //     $scope.price = response.data.ticket_price_formatted;
                    // });

                    $scope.price = $scope.tickets['price_formatted'];
                }
            }
        };
    }

}(angular));
